/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkNews } from '../models/work-news';

@Injectable({ providedIn: 'root' })
export class WorkNewsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `newsV1ControllerFindAll()` */
  static readonly NewsV1ControllerFindAllPath = '/v1/news';

  /**
   * Required permissions: news:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkNews>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsService.NewsV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkNews>>;
      })
    );
  }

  /**
   * Required permissions: news:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkNews>> {
    return this.newsV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkNews>>): Array<WorkNews> => r.body)
    );
  }

  /** Path part for operation `newsV1ControllerFindOne()` */
  static readonly NewsV1ControllerFindOnePath = '/v1/news/{id}';

  /**
   * Required permissions: news:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV1ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerFindOne$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsService.NewsV1ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * Required permissions: news:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV1ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerFindOne(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.newsV1ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `newsV1ControllerDelete()` */
  static readonly NewsV1ControllerDeletePath = '/v1/news/{id}';

  /**
   * Required permissions: news:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV1ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsService.NewsV1ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: news:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV1ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV1ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.newsV1ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
